// extracted by mini-css-extract-plugin
export default {"letter":"LoaderLetterReveal_letter__-fVHg","letterWrapper":"LoaderLetterReveal_letterWrapper__4-9-l"};